export default __webpack_public_path__ + "static/media/Safety Handrails.ec8e077b.jpg";